import axios from 'axios';
import md5 from 'md5';

export const getList = (token, payload) => {
    const headers = {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
    };

    return axios.post(`${process.env.REACT_APP_API}/customer-management/list`, payload, { headers })
    .then(function(response) {
        return response.data;
    })
    .catch(error => {
        if (error.response.status === 401)  {
            localStorage.removeItem('token');
            return window.location.href = '/';
        } else if (error.response.status === 404) {
            return window.location.href = '/404';
        }

        return error.response;
    });
}

export const create = (token, payload) => {
    const headers = {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
    };
    
    if (payload.password) {
        payload.password = md5(payload.password);
    } else {
        delete payload.password;
    }

    return axios.post(`${process.env.REACT_APP_API}/customer-management`, payload, { headers })
    .then(function(response) {
        return response.data;
    })
    .catch(error => {
        if (error.response.status === 401)  {
            localStorage.removeItem('token');
            return window.location.href = '/';
        } else if (error.response.status === 404) {
            return window.location.href = '/404';
        }

        return error.response;
    });
}

export const getInformation = (token, id) => {
    const headers = {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
    };

    return axios.get(`${process.env.REACT_APP_API}/customer-management/${id}`, { headers })
    .then(function(response) {
        return response.data;
    })
    .catch(error => {
        if (error.response.status === 401)  {
            localStorage.removeItem('token');
            return window.location.href = '/';
        } else if (error.response.status === 404) {
            return window.location.href = '/404';
        }

        return error.response;
    });
}

export const getPricingCategories = (token) => {
    const headers = {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
    };

    return axios.get(`${process.env.REACT_APP_API}/customer-pricing/categories`, { headers })
    .then(function(response) {
        return response.data;
    })
    .catch(error => {
        if (error.response?.status === 401) {
            localStorage.removeItem('token');
            return window.location.href = '/';
        }

        return error.response;
    });
}

export const getPricing = (token, id) => {
    const headers = {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
    };

    return axios.get(`${process.env.REACT_APP_API}/customer-management/${id}/pricing`, { headers })
    .then(function(response) {
        return response.data;
    })
    .catch(error => {
        if (error.response?.status === 401) {
            localStorage.removeItem('token');
            return window.location.href = '/';
        }

        return error.response;
    });
}

export const updatePricing = (token, id, rules) => {
    const headers = {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
    };

    return axios.put(
        `${process.env.REACT_APP_API}/customer-management/${id}/pricing`,
        { rules },
        { headers }
    )
    .then(function(response) {
        return response.data;
    })
    .catch(error => {
        if (error.response?.status === 401) {
            localStorage.removeItem('token');
            return window.location.href = '/';
        }

        return error.response;
    });
}

export const searchProductsForMarkup = (token, id, query) => {
    const headers = { Authorization: `Bearer ${token}` };
    return axios.get(
        `${process.env.REACT_APP_API}/customer-management/${id}/product-markup-overrides/products`,
        { headers, params: { query } }
    ).then(response => response.data).catch(error => error.response);
}

export const saveProductMarkup = (token, customerId, productId, adjustmentType, adjustmentValue) => {
    const headers = {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
    };
    return axios.put(
        `${process.env.REACT_APP_API}/customer-management/${customerId}/product-markup-overrides/${productId}`,
        { adjustment_type: adjustmentType, adjustment_value: adjustmentValue },
        { headers }
    ).then(response => response.data).catch(error => error.response);
}

export const removeProductMarkup = (token, customerId, productId) => {
    const headers = { Authorization: `Bearer ${token}` };
    return axios.delete(
        `${process.env.REACT_APP_API}/customer-management/${customerId}/product-markup-overrides/${productId}`,
        { headers }
    ).then(response => response.data).catch(error => error.response);
}

export const bulkProductMarkups = async (token, customerId, file, fingerprint) => {
    const form = new FormData();
    form.append('file', file);
    if (fingerprint) form.append('fingerprint', fingerprint);
    const action = fingerprint ? 'import' : 'validate';
    try {
        const response = await axios.post(
            `${process.env.REACT_APP_API}/customer-management/${customerId}/product-markup-overrides/bulk/${action}`,
            form,
            { headers: { Authorization: `Bearer ${token}` } }
        );
        return response.data;
    } catch (error) {
        return {
            status: error.response?.status || 0,
            ...(error.response?.data || { message: 'Connection failed. Please try again.' }),
            failed: true,
        };
    }
}

export const update = (token, payload, id) => {
    const headers = {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
    };

    if (payload.password) {
        payload.password = md5(payload.password);
    } else {
        delete payload.password;
    }

    return axios.patch(`${process.env.REACT_APP_API}/customer-management/${id}`, payload, { headers })
    .then(function(response) {
        return response.data;
    })
    .catch(error => {
        if (error.response.status === 401)  {
            localStorage.removeItem('token');
            return window.location.href = '/';
        } else if (error.response.status === 404) {
            return window.location.href = '/404';
        }

        return error.response;
    });
}



export const updatePassword = (token, payload) => {
    const headers = {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
    };
    
    if (payload.password) {
        payload.password = md5(payload.password);
    } else {
        delete payload.password;
    }

    if (payload['new-password']) {
        payload['new-password'] = md5(payload['new-password']);
    } else {
        delete payload['new-password'];
    }

    return axios.post(`${process.env.REACT_APP_API}/password/update`, payload, { headers })
    .then(function(response) {
        return response.data;
    })
    .catch(error => {
        if (error.response.status === 401)  {
            localStorage.removeItem('token');
            return window.location.href = '/';
        } else if (error.response.status === 404) {
            return window.location.href = '/404';
        }

        return error.response;
    });
}


export const getMyInformation = (token) => {
    const headers = {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
    };

    return axios.post(`${process.env.REACT_APP_API}/information`, {}, { headers })
    .then(function(response) {
        return response.data;
    })
    .catch(error => {
        if (error.response.status === 401)  {
            localStorage.removeItem('token');
            return window.location.href = '/';
        } else if (error.response.status === 404) {
            return window.location.href = '/404';
        }

        return error.response;
    });
}
